import { SaveOutlined } from "@ant-design/icons";
import { Col, Input, Row } from "antd";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Button from "../../components/functional_components/Button/PFButton";
import DetailBox from "../../components/functional_components/DetailBox/DetailBox";
import { setLoading } from "../../redux/ducks/Loading";
import { showError, showSuccess, trimData } from "../../utils/utilities";
import AccountingBookSettings from "../../services/api/AccountingBookSettings";
import { useFormik } from "formik";

const Setting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    settingData: {},
  });

  useEffect(() => {
    getCurrentSettings();
  }, []);

  const getCurrentSettings = async () => {
    dispatch(setLoading(true));
    const setting = await AccountingBookSettings.getSetting();
    if (setting) {
      setState((prevState) => ({ ...prevState, settingData: setting.data }));
    } else {
      showError(get(setting, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const formikSetting = useFormik({
    initialValues: {
      address: get(state.settingData, "address", null),
      city: get(state.settingData, "city", null),
      country: get(state.settingData, "country", null),
      name: get(state.settingData, "name", null),
      province: get(state.settingData, "province", null),
      vat: get(state.settingData, "vat", null),
      zipCode: get(state.settingData, "zipCode", null),
    },
    validate: (values) => {
      values = trimData(values);
      let errors = {};
      if (!values.address) {
        errors.address = "Required!";
      }
      if (!values.city) {
        errors.city = "Required!";
      }
      if (!values.country) {
        errors.country = "Required!";
      }
      if (!values.name) {
        errors.name = "Required!";
      }
      if (!values.province) {
        errors.province = "Required!";
      }
      if (!values.vat) {
        errors.vat = "Required!";
      }
      if (!values.zipCode) {
        errors.zipCode = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      const saveResponse = await AccountingBookSettings.saveSetting(values);
      if (saveResponse) {
        showSuccess();
        getCurrentSettings();
      } else {
        showError(get(saveResponse, "error.messageCode", "ER000"));
      }
      dispatch(setLoading(false));
    },
  });

  return (
    <DetailBox title={t("lgSettings.settingsTitle")}>
      <Row gutter={[40, 24]} justify="space-around">
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="name">
              {t("lgSettings.name")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="name"
              name="name"
              placeholder={t("lgSettings.name")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.name}
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="vat">
              {t("lgSettings.vat")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="vat"
              name="vat"
              placeholder={t("lgSettings.vat")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.vat}
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="country">
              {t("lgSettings.country")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="country"
              name="country"
              placeholder={t("lgSettings.country")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.country}
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="city">
              {t("lgSettings.city")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="city"
              name="city"
              placeholder={t("lgSettings.city")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.city}
            />
          </Row>
        </Col>
        <Col lg={22} md={22} xs={24} sm={22}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="address">
              {t("lgSettings.address")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="address"
              name="address"
              placeholder={t("lgSettings.address")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.address}
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="province">
              {t("lgSettings.province")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="province"
              name="province"
              placeholder={t("lgSettings.province")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.province}
            />
          </Row>
        </Col>
        <Col lg={10} md={10} xs={24} sm={10}>
          <Row>
            <label className="fw-bold mt-10" htmlFor="zipCode">
              {t("lgSettings.zipCode")}*
            </label>
          </Row>
          <Row>
            <Input
              required
              id="zipCode"
              name="zipCode"
              placeholder={t("lgSettings.zipCode")}
              onChange={formikSetting.handleChange}
              onBlur={formikSetting.handleBlur}
              value={formikSetting.values.zipCode}
            />
          </Row>
        </Col>
      </Row>
      <Row justify="end" className="mt-1em">
        <Button
          key="saveButton"
          currentIcon={<SaveOutlined className="icon-medium" />}
          clickCallback={formikSetting.submitForm}
          isDisabled={!(formikSetting.dirty && formikSetting.isValid)}
        />
      </Row>
    </DetailBox>
  );
};

export default Setting;
